import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  Flex,
  Divider,
  useToast,
  Select,
} from "@chakra-ui/react";
import { HomeContext } from "../../../context/HomeContext";
import IconCardM from "../../layouts/IconCardM";
import Picto1 from "./picto1/Picto1.png";
import Picto2 from "./picto1/Picto2.png";
import Picto3 from "./picto1/Picto3.png";

const StepOne = ({ onNext, onBack }) => {
  const [formData, setFormData] = useContext(HomeContext);
  const [isFormValid, setIsFormValid] = useState(false);
  const toast = useToast();

  const handleNextClick = () => {
    if (isFormValid) {
      onNext();
    } else {
      toast({
        title: "Champs manquants",
        description:
          "Veuillez remplir tous les champs obligatoires pour continuer.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    const isValid =
      formData.ballonThermoSelected &&
      formData.panneauxSelected &&
      formData.pompeModeleSelected;
    setIsFormValid(isValid);
  }, [formData]);

  const handleBallonChange = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePanneauxChange = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePompeChange = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handlePompeModeleChange = (name, value) => {
    const puissanceMatch = value.match(/(\d+)\s*kw/i);
    const puissance = puissanceMatch ? puissanceMatch[1] : "0";
    
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
      pompeSelected: puissance,
    }));
  };

  const baremeAideTable = {
    1: { bleu: 24031, jaune: 29253, violet: 40851, rose: 40852 },
    2: { bleu: 35270, jaune: 42933, violet: 60051, rose: 60052 },
    3: { bleu: 42357, jaune: 51564, violet: 71846, rose: 71847 },
    4: { bleu: 49455, jaune: 60208, violet: 84562, rose: 84563 },
    5: { bleu: 56580, jaune: 68877, violet: 96817, rose: 96818 },
    6: { bleu: 63696, jaune: 77540, violet: 109074, rose: 109075 },
    7: { bleu: 70812, jaune: 86203, violet: 121331, rose: 121332 },
    8: { bleu: 77928, jaune: 94866, violet: 133588, rose: 133589 },
    9: { bleu: 85044, jaune: 103529, violet: 145845, rose: 145846 },
    10: { bleu: 92160, jaune: 112192, violet: 158102, rose: 158103 },
  };
  const baremeAideTableProvince = {
    1: { bleu: 17363, jaune: 22259, violet: 31185, rose: 31186 },
    2: { bleu: 25393, jaune: 32553, violet: 45842, rose: 45843 },
    3: { bleu: 30540, jaune: 39148, violet: 55196, rose: 55197 },
    4: { bleu: 35676, jaune: 45735, violet: 64550, rose: 64551 },
    5: { bleu: 40835, jaune: 52348, violet: 73907, rose: 73908 },
    6: { bleu: 45986, jaune: 58946, violet: 83264, rose: 83265 },
    7: { bleu: 51137, jaune: 65544, violet: 92621, rose: 92622 },
    8: { bleu: 56288, jaune: 72142, violet: 101978, rose: 101979 },
    9: { bleu: 61439, jaune: 78740, violet: 111335, rose: 111336 },
    10: { bleu: 66590, jaune: 85338, violet: 120692, rose: 120693 },
  };

  const revenuFiscal = formData.revenuFiscal;
  const numberOfOccupants = formData.numberOfOccupants;
  const factureElectricite = formData.factureElectricite;
  const typeChauffage = formData.sourceType;
  const productionECS = formData.energieType;
  const factureSecondaire = formData.factureSecondaire;
  const departement = formData.departement;
  const altitude = formData.altitude;

  formData.consommationElectrique = factureElectricite / 0.17;

  const getAideColor = () => {
    // Choix du tableau de barème en fonction de la localisation
    const baremeAideTableToUse =
      formData.provinceOuIdf === "Ile de France"
        ? baremeAideTable
        : baremeAideTableProvince;

    const aides = baremeAideTableToUse[numberOfOccupants] || {};

    if (revenuFiscal < aides.bleu) {
      return "bleu";
    } else if (revenuFiscal < aides.jaune) {
      return "jaune";
    } else if (revenuFiscal < aides.violet) {
      return "violet";
    } else {
      return "rose";
    }
  };

  formData.aideColor = getAideColor(numberOfOccupants, revenuFiscal);
  const colorScheme = {
    bleu: "blue",
    jaune: "yellow",
    violet: "purple",
    rose: "pink",
  };

  const result = getAideColor();

  const calculateDepenseECS = () => {
    if (formData.energieType === "Chaudiere") {
      return formData.factureSecondaire * 0.3;
    } else if (formData.sourceType === "ELECTRICITE") {
      return formData.factureElectricite * 0.3;
    }
    return formData.factureElectricite * 0.6;
  };

  function calculateDepenseChauffage() {
    if (formData.sourceType === "ELECTRICITE") {
      return formData.factureElectricite * 0.6;
    } else if (formData.energieType === "Chaudiere") {
      return formData.factureSecondaire * 0.7;
    } else {
      return formData.factureSecondaire;
    }
  }

  formData.depenseChauffage = calculateDepenseChauffage(formData);

  formData.depenseECS = calculateDepenseECS();
  formData.depenseMenager =
    formData.factureElectricite +
    formData.factureSecondaire -
    formData.depenseChauffage -
    formData.depenseECS;

  const deptZoneMapping = {
    1: "G",
    2: "D",
    3: "E",
    4: "E",
    5: "G",
    6: "A",
    7: "D",
    8: "G",
    9: "C",
    10: "G",
    11: "C",
    12: "E",
    13: "C",
    14: "D",
    15: "E",
    16: "C",
    17: "C",
    18: "D",
    19: "E",
    21: "G",
    22: "B",
    23: "E",
    24: "C",
    25: "H",
    26: "D",
    27: "D",
    28: "D",
    29: "B",
    30: "C",
    31: "C",
    32: "C",
    33: "B",
    34: "C",
    35: "C",
    36: "D",
    37: "D",
    38: "G",
    39: "G",
    40: "C",
    41: "D",
    42: "G",
    43: "E",
    44: "C",
    45: "D",
    46: "D",
    47: "C",
    48: "E",
    49: "D",
    50: "B",
    51: "G",
    52: "H",
    53: "D",
    54: "I",
    55: "H",
    56: "B",
    57: "I",
    58: "G",
    59: "F",
    60: "D",
    61: "D",
    62: "F",
    63: "E",
    64: "C",
    65: "C",
    66: "C",
    67: "I",
    68: "I",
    69: "G",
    70: "H",
    71: "G",
    72: "D",
    73: "G",
    74: "G",
    75: "D",
    76: "D",
    77: "D",
    78: "D",
    79: "D",
    80: "F",
    81: "C",
    82: "C",
    83: "C",
    84: "D",
    85: "C",
    86: "D",
    87: "E",
    88: "I",
    89: "G",
    90: "I",
    91: "D",
    92: "D",
    93: "D",
    94: "D",
    95: "D",
  };

  const baseTempTable = {
    "0 à 200m": {
      A: -2,
      B: -4,
      C: -5,
      D: -7,
      E: -8,
      F: -9,
      G: -10,
      H: -12,
      I: -15,
    },
    "201 à 400m": {
      A: -4,
      B: -5,
      C: -6,
      D: -8,
      E: -9,
      F: -10,
      G: -11,
      H: -13,
      I: -15,
    },
    "401 à 600m": {
      A: -6,
      B: -6,
      C: -7,
      D: -9,
      E: -11,
      F: -11,
      G: -13,
      H: -15,
      I: -19,
    },
    "601 à 800m": {
      A: -8,
      B: -7,
      C: -8,
      D: -11,
      E: -13,
      F: -12,
      G: -14,
      H: -17,
      I: -21,
    },
    "801 à 1000m": {
      A: -10,
      B: -8,
      C: -9,
      D: -13,
      E: -15,
      F: -13,
      G: -17,
      H: -19,
      I: -23,
    },
    "1001 à 1200m": {
      A: -12,
      B: -9,
      C: -10,
      D: -14,
      E: -17,
      G: -19,
      H: -21,
      I: -24,
    },
    "1201 à 1400m": {
      A: -14,
      B: -10,
      C: -11,
      D: -15,
      E: -19,
      G: -21,
      H: -23,
      I: -25,
    },
    "1401 à 1600m": {
      A: -14,
      B: -10,
      C: -11,
      D: -15,
      E: -19,
      G: -21,
      H: -23,
      I: -25,
    },
    "1601 à 1800m": {
      A: -18,
      C: -13,
      E: -23,
      G: -24,
    },
    "1801 à 2000m": {
      A: -20,
      C: -14,
      E: -25,
      G: -25,
    },
    "2001 à 2200m": {
      C: -15,
      E: -27,
      G: -29,
    },
  };

  const getBaseTemperature = () => {
    const zone = deptZoneMapping[formData.departement];
    const altitudeRange = formData.altitude;

    if (baseTempTable[altitudeRange] && baseTempTable[altitudeRange][zone]) {
      return baseTempTable[altitudeRange][zone];
    } else {
      console.error(
        "Altitude range not found or does not exist in baseTempTable"
      );
      return null;
    }
  };

  formData.baseTemperature = getBaseTemperature();

  const orientationInclinaisonMatrix = {
    SUD: {
      "0": 1,
      "15": 1.10,
      "25": 1.14,
      "35": 1.15,
      "45": 1.14,
      "55": 1.10,
      "60": 1.08,
    },
    "SUD_EST": {
      "0": 1,
      "15": 1.07,
      "25": 1.09,
      "35": 1.09,
      "45": 1.07,
      "55": 1.03,
      "60": 1,
    },
    "SUD_OUEST": {
      "0": 1,
      "15": 1.07,
      "25": 1.09,
      "35": 1.09,
      "45": 1.07,
      "55": 1.03,
      "60": 1,
    },
    OUEST: {
      "0": 1,
      "15": 0.99,
      "25": 0.97,
      "35": 0.94,
      "45": 0.9,
      "55": 0.84,
      "60": 0.81,
    },
    EST: {
      "0": 1,
      "15": 0.99,
      "25": 0.97,
      "35": 0.94,
      "45": 0.9,
      "55": 0.84,
      "60": 0.81,
    },
  };

  const getValueOrientation = () => {
    const orientation = formData.orientationToiture;
    const inclination = formData.inclinaisonToiture;
    if (!orientationInclinaisonMatrix[orientation]) {
      console.error(`Orientation '${orientation}' not found in the matrix.`);
      return null;
    }
    if (!orientationInclinaisonMatrix[orientation][inclination]) {
      console.error(
        `Inclination '${inclination}' not found for orientation '${orientation}'.`
      );
      return null;
    }
    const coefficient = orientationInclinaisonMatrix[orientation][inclination];
    return coefficient;
  };

  const getValueRegion = () => {
    const regionValue = formData.region;
    if (regionValue === "Diagonale Bretagne / Haute savoie") {
      return 1.31;
    } else if (regionValue === "Nord Est") {
      return 1.17;
    } else if (regionValue === "Sud est") {
      return 1.58;
    } else if (regionValue === "Ile de France") {
      return 1.19;
    } else {
      return 1.43;
    }
  };

  const valueOrientation = getValueOrientation();
  const valueRegion = getValueRegion();

  formData.solarCoefficient = null;
  if (valueOrientation !== null && valueRegion !== null) {
    formData.solarCoefficient = valueOrientation * valueRegion;
  }

  const getT17 = () => {
    const constructionYear = formData.constructionYear;
    switch (constructionYear) {
      case "avant 1975":
        return 1.6;
      case "RT 2005":
        return 0.9;
      case "RT 2012":
        return 0.75;
      case "avant 1995":
        return 1.3;
      case "RT 2000":
        return 1.1;
      default:
        console.error(`Unknown construction year label: ${constructionYear}`);
        return null;
    }
  };

  const calculateBesoinPuissanceChauffage = () => {
    const surfaceHabitable = formData.surfaceHabitable;
    const hauteurSousPlafond = formData.hauteurSousPlafond;
    const temperature = formData.temperature;
    const temperatureAdjustment = temperature + formData.baseTemperature * -1;

    const tableurT17 = getT17();
    if (tableurT17 === null) {
      return null;
    }
    const result =
      ((surfaceHabitable * hauteurSousPlafond * temperatureAdjustment) / 1000) *
      tableurT17;
    return result < 11 ? 11 : result;
  };
  formData.besoinPuissanceChauffage = calculateBesoinPuissanceChauffage();
  if (formData.besoinPuissanceChauffage !== null) {
  } else {
  }

  const getTypeDePompeAChaleur = () => {
    const chauffageType = formData.chauffageType;

    switch (chauffageType) {
      case "Mixte":
        return "Haute temperature/kit bi zone";
      case "Radiateur classique":
        return "Basse temperature";
      case "Au sol":
        return "Basse temperature";
      case "Radiateur fonte":
        return "Haute temperature";
      default:
        console.error(`Unknown chauffageType label: ${chauffageType}`);
        return null;
    }
  };
  formData.typeDePompeAChaleur = getTypeDePompeAChaleur();

  const feuil2Table = [
    { B: 10.2, D: 2250 },
    { B: 11.9, D: 2625 },
    { B: 13.6, D: 3000 },
    { B: 15.3, D: 3375 },
    { B: 17.0, D: 3750 },
    { B: 18.7, D: 4125 },
    { B: 20.4, D: 4500 },
    { B: 22.1, D: 4875 },
    { B: 23.8, D: 5250 },
    { B: 25.5, D: 5625 },
    { B: 27.2, D: 6000 },
    { B: 28.9, D: 6375 },
    { B: 30.6, D: 6750 },
    { B: 32.3, D: 7125 },
    { B: 34.0, D: 7500 },
    { B: 35.7, D: 7875 },
    { B: 37.4, D: 8250 },
    { B: 39.1, D: 8625 },
    { B: 40.8, D: 9000 },
  ];

  const calculateInstallationMaximum = (surfaceHabitable) => {
    let found = false;
    let installationMaximum = null;

    for (let i = 0; i < feuil2Table.length; i++) {
      if (
        surfaceHabitable >= feuil2Table[i].B &&
        (i === feuil2Table.length - 1 ||
          surfaceHabitable < feuil2Table[i + 1].B)
      ) {
        found = true;
        installationMaximum = feuil2Table[i].D / 375;
        break;
      }
    }

    if (!found) {
      console.error(
        `Surface habitable ${surfaceHabitable} not found in the lookup table.`
      );
    }

    return installationMaximum;
  };

  formData.installationMaximum = calculateInstallationMaximum(
    formData.superficieToiture
  );
  if (formData.installationMaximum !== null) {
  } else {
  }

  formData.installationMaximum = calculateInstallationMaximum(
    formData.superficieToiture
  );
  if (formData.installationMaximum !== null) {
  } else {
  }

  formData.solarCoefficient = null;
  if (valueOrientation !== null && valueRegion !== null) {
    formData.solarCoefficient = valueOrientation * valueRegion;
  }

  const calculateInstallationRecommandee = () => {
    const M21 = formData.energieType === "Ballon";

    const G30 = formData.consommationElectrique;

    const G32 = formData.depenseECS;

    const F21 = formData.pompeSelected ? parseInt(formData.pompeSelected) : 0;

    const F22 = (F21 / 5) * 1000;

    const N12 = G32 / 0.17;

    const M22 = N12 * 0.25;

    let U11;
    if (formData.ballonThermoSelected === "Oui") {
      U11 =
        formData.consommationElectrique -
        (formData.depenseECS / 0.17 -
          (formData.depenseECS / 0.17) * 0.25 +
          (F21 / 5) * 1000);
    } else {
      U11 = G30 + M22 + F22;
    }

    formData.consoAnnuellePompe = F22;

    const U12 = formData.solarCoefficient;
    formData.consoAnnuellePanneaux = U11;

    const result = U11 / (425 * U12 * 0.85);
    return Math.min(result, 21);
  };

  formData.installationRecommandee = calculateInstallationRecommandee();
  // formData.installationRecommandee = Math.round(calculateInstallationRecommandee());
  formData.besoinPuissanceChauffage = Math.ceil(
    calculateBesoinPuissanceChauffage()
  );
  formData.besoinPuissanceChauffage = Math.floor(
    calculateBesoinPuissanceChauffage()
  );

  return (
    <Box width="full" px={20}>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mb={8}
      >
        <Box>
          <Heading fontSize={"28px"} mb={2} fontWeight={"510"} color="#2D3748">
            Projet du client
          </Heading>
          <Text color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Sélectionnez le projet adapté pour le client
          </Text>
        </Box>
        <Button
          w="140px"
          h="45px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          border="1px solid"
          borderColor="#30C9FF"
          _hover={{
            bgColor: "#30C9FF",
            color: "white",
            transform: "translateY(-2px)",
            transition: "all 0.2s",
          }}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "40px" }}
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        boxShadow="0px 4px 20px rgba(0, 0, 0, 0.05)"
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          width={"100%"}
          gap={16}
        >
          {/* Première rangée */}
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            width={"100%"}
            gap={12}
          >
            {/* Ballon Thermodynamique */}
            <Box
              w={"450px"}
              h={"500px"}
              bg="white"
              borderRadius={"20px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="140px"
              >
                <IconCardM icon={Picto1} />
              </Box>
              <Box p={8}>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={6}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Ballon thermodynamique
              </Text>
                <Select
                  name="ballonThermoSelected"
                  mb={4}
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.ballonThermoSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handleBallonChange("ballonThermoSelected", e.target.value)
                  }
                  value={formData.ballonThermoSelected}
                >
                  <option value="">Choisir le modele</option>
                  <option value="0">Aucun</option>
                  <option value="Oui">Ballon Thermodynamique 250 L </option>
                </Select>
                <Select
                  mb={4}
                  name="cacheClimBallonSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={
                    formData.cacheClimBallonSelected ? "#2D3748" : "#A7A7A7"
                  }
                  onChange={(e) =>
                    handleBallonChange(
                      "cacheClimBallonSelected",
                      e.target.value
                    )
                  }
                  value={formData.cacheClimBallonSelected}
                >
                  <option value="Sans">Cache clim</option>
                  <option value="Avec">Avec (590€)</option>
                </Select>
            </Box>
            </Box>

            {/* Panneaux Photovoltaïques */}
            <Box
              w={"450px"}
              h={"500px"}
              bg="white"
              borderRadius={"20px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="140px"
              >
                <IconCardM icon={Picto3} />
              </Box>
              <Box p={8}>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={6}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Panneaux photovoltaïques
              </Text>
                <Select
                  name="panneauxSelected"
                  mb={4}
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.panneauxSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handlePanneauxChange("panneauxSelected", e.target.value)
                  }
                  value={formData.panneauxSelected}
                >
                  <option value="">Choisir le nombre de panneaux</option>
                  <option value="0">Aucun</option>
                  <option value="6">
                    6 PANNEAUX (3 kWc pas de recup TVA)
                  </option>
                  <option value="7">
                    7 PANNEAUX (3,5 kWc pas de recup TVA)
                  </option>
                  <option value="8">8 PANNEAUX (4 kWc)</option>
                  <option value="9">9 PANNEAUX (4,5 kWc)</option>
                  <option value="10">10 PANNEAUX (5 kWc)</option>
                  <option value="11">11 PANNEAUX (5,5 kWc)</option>
                  <option value="12">12 PANNEAUX (6 kWc)</option>
                  <option value="13">13 PANNEAUX (6,5 kWc)</option>
                  <option value="14">14 PANNEAUX (7 kWc)</option>
                  <option value="15">15 PANNEAUX (7,5 kWc)</option>
                  <option value="16">16 PANNEAUX (8 kWc)</option>
                  <option value="17">17 PANNEAUX (8,5 kWc)</option>
                  <option value="18">18 PANNEAUX (9 kWc)</option>
                  <option value="20">20 PANNEAUX (10 kWc)</option>
                  <option value="24">24 PANNEAUX (12 kWc)</option>
                  <option value="30">30 PANNEAUX (15 kWc)</option>
                  <option value="72">72 PANNEAUX (36 kWc)</option>
                </Select>
                <Select
                  name="carportBoisSelected"
                  mb={4}
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.carportBoisSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handlePanneauxChange("carportBoisSelected", e.target.value)
                  }
                  value={formData.carportBoisSelected}
                >
                  <option value="Sans">Carport Bois</option>
                  <option value="Avec">Avec (4200€)</option>
                </Select>
                <Select
                  name="desinstallationPanneauxSelected"
                  mb={4}
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={
                    formData.desinstallationPanneauxSelected
                      ? "#2D3748"
                      : "#A7A7A7"
                  }
                  onChange={(e) =>
                    handlePanneauxChange(
                      "desinstallationPanneauxSelected",
                      e.target.value
                    )
                  }
                  value={formData.desinstallationPanneauxSelected}
                >
                  <option value="Sans">Désinstallation panneaux</option>
                  <option value="Avec">Avec (2200€)</option>
                </Select>

                {/* Box des recommandations compacte */}
                <Box 
                  width={"100%"}
                  p={2} 
                  bg="#F7FAFC" 
                  borderRadius="8px"
                  border="1px dashed #CBD5E0"
                >
                  <Text
                    fontSize={"12px"}
                    fontWeight={"400"}
                    color="#4A5568"
                    textAlign="center"
                    mb={1}
                  >
                    Max: {formData.installationMaximum} panneaux | Recommandé: {Math.floor(formData.installationRecommandee)} panneaux
              </Text>
            </Box>
          </Box>
            </Box>
          </Box>

          {/* Deuxième rangée */}
              <Box
                display={"flex"}
            flexDirection={"row"}
            justifyContent={"center"}
            width={"100%"}
            gap={12}
          >
            {/* Pompe à chaleur air/eau */}
            <Box
              w={"450px"}
              h={"500px"}
              bg="white"
                borderRadius={"20px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="140px"
              >
                <IconCardM icon={Picto2} />
              </Box>
              <Box p={8}>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={6}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Pompe à chaleur air/eau
                </Text>
                <Select
                  mb={4}
                  name="pompeModeleSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.pompeModeleSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handlePompeModeleChange(
                      "pompeModeleSelected",
                      e.target.value
                    )
                  }
                  value={formData.pompeModeleSelected}
                >
                  <option value="">Choisir le modele</option>
                  <option value="0">Aucune</option>
                  <option value="Pompe air eau Ariston Nimbus : 80 S (8 kw)">
                    Pompe air eau Ariston Nimbus : 80 S (8 kw)
                  </option>
                  <option value="Pompe air eau Thompson Ether (10 kw)">
                    Pompe air eau Thompson Ether (10 kw)
                  </option>
                  <option value="Pompe air eau Atlantic Duo Ballon integre (11 kw)">
                    Pompe air eau Atlantic Duo Ballon integre (11 kw)
                  </option>
                  <option value="Pompe air eau Ariston Nimbus : 120 S (12 kw)">
                    Pompe air eau Ariston Nimbus : 120 S (12 kw)
                  </option>
                  <option value="Pompe air eau Atlantic Duo Ballon integre (14 kw)">
                    Pompe air eau Atlantic Duo Ballon integre (14 kw)
                  </option>
                  <option value="Pompe air eau Thompson Ether (14 kw)">
                    Pompe air eau Thompson Ether (14 kw)
                  </option>
                  <option value="Pompe air eau Daikin Altherma 3H (14 kw)">
                    Pompe air eau Daikin Altherma 3H (14 kw)
                  </option>
                  <option value="Pompe air eau Daikin Erla MT plancher chauffant (14 kw)">
                    Pompe air eau Daikin Erla MT plancher chauffant (14 kw)
                  </option>
                  <option value="Pompe air eau Ariston Nimbus : 150 S (15 kw)">
                    Pompe air eau Ariston Nimbus : 150 S (15 kw)
                  </option>
                  <option value="Pompe air eau Atlantic Duo Ballon integre (16 kw)">
                    Pompe air eau Atlantic Duo Ballon integre (16 kw)
                  </option>
                  <option value="Pompe air eau Thompson Ether (16 kw)">
                    Pompe air eau Thompson Ether (16 kw)
                  </option>
                  <option value="Pompe air eau Daikin Altherma 3H (16 kw)">
                    Pompe air eau Daikin Altherma 3H (16 kw)
                  </option>
                  <option value="Pompe air eau Daikin Erla MT plancher chauffant (16 kw)">
                    Pompe air eau Daikin Erla MT plancher chauffant (16 kw)
                  </option>
                  <option value="Pompe air eau Daikin Altherma 3H (18 kw)">
                    Pompe air eau Daikin Altherma 3H (18 kw)
                  </option>
                  <option value="Pompe air eau FHE Inelio Mono-bloc Tri-phasé (22 kw)">
                    Pompe air eau FHE Inelio Mono-bloc Tri-phasé (22 kw)
                  </option>
                  <option value="Pompe air eau FHE Inelio Mono-bloc Tri-phasé (26 kw)">
                    Pompe air eau FHE Inelio Mono-bloc Tri-phasé (26 kw)
                  </option>
                  <option value="Pompe air eau FHE Inelio Mono-bloc Tri-phasé (30 kw)">
                    Pompe air eau FHE Inelio Mono-bloc Tri-phasé (30 kw)
                  </option>
                </Select>
                <Select
                  mb={4}
                  name="bizoneSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.bizoneSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handlePompeChange("bizoneSelected", e.target.value)
                  }
                  value={formData.bizoneSelected}
                >
                  <option value="Sans">Kit bi zone plancher chauffant</option>
                  <option value="Avec">Avec (1660€)</option>
                </Select>
                <Select
                  mb={4}
                  name="cacheClimPompeEauSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={
                    formData.desembouage && formData.desembouage !== "" ? "#2D3748" : "#A7A7A7"
                  }
                  onChange={(e) =>
                    handlePompeChange(
                      "desembouage",
                      e.target.value
                    )
                  }
                  value={formData.desembouage}
                >
                  <option value="Sans">Desembouage</option>
                  <option value="Avec">Avec (844€)</option>
                </Select>
                <Select
                  mb={4}
                  name="cacheClimPompeEauSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={
                    formData.cacheClimPompeEauSelected && formData.cacheClimPompeEauSelected !== "" ? "#2D3748" : "#A7A7A7"
                  }
                  onChange={(e) =>
                    handlePompeChange(
                      "cacheClimPompeEauSelected",
                      e.target.value
                    )
                  }
                  value={formData.cacheClimPompeEauSelected}
                >
                  <option value="Sans">Cache clim</option>
                  <option value="Avec">Avec (590€)</option>
                </Select>
                  {formData.besoinPuissanceChauffage && (
                  <Box
                    mt={2}
                    p={3}
                    bg="#F7FAFC"
                    borderRadius="8px"
                    border="1px dashed #CBD5E0"
                  >
                      <Text
                      fontSize={"15px"}
                      fontWeight={"500"}
                      color="#4A5568"
                      textAlign="center"
                    >
                      Puissance recommandée :{" "}
                        {formData.besoinPuissanceChauffage} kw
                      </Text>
                    </Box>
                  )}
              </Box>
            </Box>

            {/* Pompe à chaleur air/air */}
            <Box
              w={"450px"}
              h={"500px"}
              bg="white"
                borderRadius={"20px"}
              border="1px solid"
              borderColor={"#F4F4F4"}
              overflow="hidden"
              transition="all 0.3s"
              _hover={{
                boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
                transform: "translateY(-4px)",
              }}
            >
              <Box
                bg="#FCFDFF"
                p={6}
                display="flex"
                justifyContent="center"
                alignItems="center"
                h="140px"
              >
                <IconCardM icon={Picto2} />
              </Box>
              <Box p={8}>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  color="#8C8C8C"
                  mb={6}
                  textAlign="center"
                  textTransform="uppercase"
                >
                  Pompe à chaleur air/air
                </Text>
                <Select
                  mb={4}
                  name="pompeAirAirSelected"
                  width={"100%"}
                  height={"40px"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={formData.pompeAirAirSelected ? "#2D3748" : "#A7A7A7"}
                  onChange={(e) =>
                    handlePompeChange("pompeAirAirSelected", e.target.value)
                  }
                  value={formData.pompeAirAirSelected}
                >
                  <option value="">Choisir le modèle</option>
                  <option value="0">Aucun</option>
                  <option value="Fournitures et pose d'une air air 7 sorties (19990€)">
                    Fournitures et pose d'une air air 7 sorties (19990€)
                  </option>
                  <option value="Fournitures et pose d'une air air 6 sorties (17490€)">
                    Fournitures et pose d'une air air 6 sorties (17490€)
                  </option>
                  <option value="Fournitures et pose d'une air air 5 sorties (14490€)">
                    Fournitures et pose d'une air air 5 sorties (14490€)
                  </option>
                  <option value="Fournitures et pose d'une air air 4 sorties (12350€)">
                    Fournitures et pose d'une air air 4 sorties (12350€)
                  </option>
                  <option value="Fournitures et pose d'une air air 3 sorties (9899€)">
                    Fournitures et pose d'une air air 3 sorties (9899€)
                  </option>
                  <option value="Fournitures et pose d'une air air 2 sorties (3900€)">
                    Fournitures et pose d'une air air 2 sorties (3900€)
                  </option>
                </Select>
              <Select
                  mb={4}
                  name="cacheClimPompeAirSelected"
                  width={"100%"}
                  height={"40px"}
                fontWeight={"400"}
                fontSize={"13px"}
                  bg="white"
                  borderColor="#F4F4F4"
                  _hover={{ borderColor: "#30C9FF" }}
                  _focus={{
                    borderColor: "#30C9FF",
                    boxShadow: "0 0 0 1px #30C9FF",
                  }}
                  color={
                    formData.cacheClimPompeAirSelected && formData.cacheClimPompeAirSelected !== "" ? "#2D3748" : "#A7A7A7"
                  }
                onChange={(e) =>
                    handlePompeChange(
                      "cacheClimPompeAirSelected",
                      e.target.value
                    )
                  }
                  value={formData.cacheClimPompeAirSelected}
                >
                  <option value="Sans">Cache clim</option>
                  <option value="Avec">Avec (590€)</option>
              </Select>
                    </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
      <Flex justifyContent="flex-end" mt={8}>
        <Button
          w="280px"
          h="50px"
          bgColor="#30C9FF"
          color="#FCFDFF"
          fontWeight="600"
          fontSize="14px"
          borderRadius="8px"
          _hover={{
            bgColor: "#30C9FF",
            transform: "translateY(-2px)",
            boxShadow: "0px 6px 20px rgba(48, 201, 255, 0.15)",
          }}
          transition="all 0.2s"
          onClick={handleNextClick}
        >
          Confirmez les informations
        </Button>
      </Flex>
    </Box>
  );
};

export default StepOne;
